import React from "react";
import PropTypes from "prop-types";

export const Search = ({ size = 24, color }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.4756 22C21.343 22 21.2108 21.9493 21.1086 21.8474L15.4906 16.2479C15.2835 16.042 15.2809 15.7037 15.4833 15.4935C15.6857 15.2828 16.0176 15.2796 16.2248 15.4861L21.8427 21.0856C22.0499 21.2915 22.0525 21.6298 21.8501 21.84C21.7478 21.9461 21.6115 22 21.4756 22Z" />
      <path d="M9.77778 17.5556C5.48907 17.5556 2 14.067 2 9.77778C2 5.48907 5.48907 2 9.77778 2C14.0665 2 17.5556 5.48907 17.5556 9.77778C17.5556 14.067 14.0665 17.5556 9.77778 17.5556ZM9.77778 3.05686C6.07164 3.05686 3.05633 6.07163 3.05633 9.77831C3.05633 13.4845 6.07111 16.4998 9.77778 16.4998C13.4839 16.4998 16.4992 13.4845 16.4992 9.77831C16.4992 6.07216 13.4839 3.05686 9.77778 3.05686Z" />
    </svg>
  );
};

Search.defaultProps = {
  size: 24,
  color: "currentColor",
};

Search.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};
